import axios from "axios";
import {redirectToLogin} from "../components/router/redirect";

const axiosClient = axios.create({
    baseURL: `${import.meta.env.VITE_API_BASE_URL}/api`,
});

/**
 * Routes de réponse aux questionnaires publics. Seules celles-ci ont besoin du
 * cookie d'Appareil qui porte l'unicité des réponses (cf. ADR 0006) : envoyer
 * les credentials partout exigerait des origines CORS nommées sur toute l'API.
 */
const CREDENTIALED_PATHS = /^\/public-survey-response/;

axiosClient.interceptors.request.use((config) => {
    if (config.url && CREDENTIALED_PATHS.test(config.url)) {
        config.withCredentials = true;
    }

    const token = localStorage.getItem("ACCESS_TOKEN");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Envoyer le facility sélectionné dans le header pour que le backend puisse filtrer
    const selectedFacilityId = localStorage.getItem("SELECTED_FACILITY_ID");
    if (selectedFacilityId) {
        config.headers["X-Facility-Id"] = selectedFacilityId;
    }

    return config;
});

axiosClient.interceptors.response.use(
    (response) => response, // Si la réponse est correcte
    (error) => {
        const { response } = error;

        if (response?.status === 401) {
            // Supprimer le token et rediriger vers la page de connexion
            localStorage.removeItem("ACCESS_TOKEN");

            // Utiliser une redirection
            redirectToLogin();
        } else if (response?.status === 403 && response.data?.code === "two_factor_enrollment_required") {
            // L'utilisateur (admin) doit enrôler sa double authentification avant d'accéder à l'app
            if (window.location.pathname !== "/two-factor/setup") {
                window.location.href = "/two-factor/setup";
            }
        } else if (response?.status === 403) {
            // Liste des URLs pour lesquelles on ne redirige PAS sur 403
            // Ces endpoints sont des requêtes background non-critiques
            const silentFailUrls = [
                '/unread-conversations-count',
                '/ai-usage',
                '/crm/urgent-tasks-count',
                '/files',
            ];

            const requestUrl = error.config?.url || '';
            const shouldRedirect = !silentFailUrls.some(url => requestUrl.includes(url));

            if (shouldRedirect) {
                // Permission refusée - émettre un événement pour que le frontend puisse réagir
                window.dispatchEvent(new CustomEvent('permission-denied', {
                    detail: { url: requestUrl }
                }));
            }
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
